import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { encrypt } from '@por/consumer-login/shared-lib';
import { ModalStateEnum } from '@por/ecom-shared';
import isEmpty from 'lodash-es/isEmpty';
import { Language } from '@por/shared/core';
import { User } from '../models';
import { ConsumerLoginConfig } from '../models/consumer-login-config';

@Component({
    standalone: false,
    selector: 'por-change-password',
    templateUrl: './change-password-component.component.html',
    styleUrls: ['./change-password-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordComponentComponent implements OnInit {
    private readonly fb = inject(FormBuilder);
    private readonly translateService = inject(TranslateService);

    @Output()
    readonly selectedTemplate: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    readonly changePasswordData: EventEmitter<User> = new EventEmitter<User>();

    @Output()
    readonly loading$: EventEmitter<boolean> = new EventEmitter<boolean>();

    inputs: ConsumerLoginConfig | undefined;
    @Input() config: string | undefined;

    @Input() isDisableButton = false;

    @Input() userEmail!: string;

    @Input() isUserDisabled = false;
    @Input() organizationId = '';
    @Input() storeName?: string;

    changePasswordForm = this.fb.group({
        code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
        password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(50)]]
    });

    modal = '';

    get password(): FormControl {
        return this.changePasswordForm.get('password') as FormControl;
    }

    get code(): FormControl {
        return this.changePasswordForm.get('code') as FormControl;
    }

    ngOnInit(): void {
        this.translateService.use(Language.EN_GB);

        if (this.config && !isEmpty(this.config)) {
            this.inputs = JSON.parse(this.config) as ConsumerLoginConfig;
        }

        this.changePasswordForm.setValue({
            password: '',
            code: ''
        });
    }

    submit(): boolean {
        if (!this.changePasswordForm.valid) {
            return false;
        }
        const password: string = this.changePasswordForm.value?.password as string;
        const code: string = this.changePasswordForm.value?.code as string;
        /* eslint-disable @typescript-eslint/naming-convention */
        /**
         * Note camelCase: DB model
         */
        this.changePasswordData.emit({
            Email: this.userEmail,
            Password: encrypt(password),
            code: code
        });
        this.loading$.emit(true);
        return true;
    }

    setTemplate(templateName: string) {
        this.selectedTemplate.emit(templateName);
    }

    openModal() {
        this.modal = ModalStateEnum.OPEN;
    }

    closeModal(event: boolean) {
        if (event) {
            this.modal = ModalStateEnum.CLOSE;
        }
    }
}
